import {observable, action, runInAction} from 'mobx'
import {json} from '../../../utils/ajax'
import {downLoad, handleSearchAndPage, setStore, ValueObjToObj, _encodeParamToSearch} from "../../../utils/Utils";
import moment from 'moment'
import {message} from "antd";

class backgroundOperationRecordStore {

    @observable loading         //后台操作记录列表数据loading
    @observable backgroundOperationRecordList  //后台操作记录列表数据
    @observable pagination      //分页
    @observable searchField //表单搜索值

    constructor() {
        this.loading = false
        this.backgroundOperationRecordList = []
        this.pagination = {
            current: 0,
            total: 1,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSize: 20,
            showTotal: () => {
            }
        }
        this.searchField = {
            account: '',
            model: '',
            type: '',
            description: '',
            startTime: '',
            endTime: '',
            rangePicker:[]
        }
    }

    /**调用setStore方法并传入当前this***/
    @action
    setStore = (obj) => {
        setStore(obj, this)
    }

    /**初始化页面*yg**/
    @action
    initBackgroundOperationRecordPage = async (page) => {
        this.loading = true
        let searchField = {
            ...this.searchField,
            model: this.searchField.model ? this.searchField.model:'',
            type:this.searchField.type ? this.searchField.type :'',
            startTime: this.searchField.rangePicker.length > 0 ? moment(this.searchField.rangePicker[0]).format("YYYY-MM-DD") : '',
            endTime: this.searchField.rangePicker.length > 0 ? moment(this.searchField.rangePicker[1]).format("YYYY-MM-DD") : ''
        };
        let searchResult = handleSearchAndPage(page, this.pagination, searchField)
        const res = await json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/operatelog/page:search`, searchResult)
        if (res && res.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        runInAction(() => {
            this.backgroundOperationRecordList = res.content ? res.content : []
            this.pagination = {
                current: res.number + 1,
                total: res.totalElements,
                showQuickJumper: true,
                showSizeChanger: true,
                pageSize: res.size,
                showTotal: () => `总共 ${res.totalElements?res.totalElements:0} 条`
            }
            this.loading = false
        })
    }

    /***搜索表单绑值**/
    @action
    onSearchField = (changedFields) => {
        this.searchField = {...this.searchField, ...ValueObjToObj(changedFields)}
    }

    /***重置**/
    @action
    handleReset=()=>{
        this.searchField = {
            account: '',
            model: '',
            type: '',
            description: '',
            startTime: '',
            endTime: '',
            rangePicker:[]
        }
        this.initBackgroundOperationRecordPage()
    }

    /***搜索表单绑值**/
    @action
    matchingExport = () => {
        let searchField = {
            ...this.searchField,
            model: this.searchField.model ? this.searchField.model:'',
            type:this.searchField.type ? this.searchField.type :'',
            startTime: this.searchField.rangePicker.length > 0 ? moment(this.searchField.rangePicker[0]).format("YYYY-MM-DD") : '',
            endTime: this.searchField.rangePicker.length > 0 ? moment(this.searchField.rangePicker[1]).format("YYYY-MM-DD") : ''
        };
        let searchResult = _encodeParamToSearch(searchField)
        downLoad(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/operatelog/exportExcel:search?${searchResult}`,'后台操作记录.xlsx')
        message.warning('导出中请稍等！')
    }
}

export default new backgroundOperationRecordStore()


// WEBPACK FOOTER //
// ./src/Backend/sparePartsCatalogue/BackgroundOperationRecord/store.js